// src/context/ToastContext.js
import React, { createContext, useState, useContext } from 'react';
import Toast from '../components/Toast/Toast';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ message: '', type: 'success' });

  const showToast = (message, type = 'success') => {
    setToast({ message, type });

    setTimeout(() => {
      setToast({ message: '', type });
    }, 3000);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast message={toast.message} type={toast.type} />
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
